
import { useContext, useEffect, useState } from 'react'
import ProductForm from '../categories&products_form/ProductForm';
import AddJobForm from '../jobs_form/AddJobForm';
import DashboardCard from "../dashboardComponents/DashboardCard";
import BranchForm from '../branch_form/BranchForm';
import AboutForm from '../about_form/AboutForm';
import HomeHeaderForm from '../homeHeader_form/HomeHeaderForm';
import { AppContext } from '../../../contextApi/ContextApi';
import AIPageForm from '../aiPage_form/AIPageForm';

export default function DashboardEditContent({website, currentCard, setCurrentCard, setEditPage}) {
  const {hasBranches, hasJobs, hasCategories} = useContext(AppContext);
  const [homeHeaderFlag, setHomeHeaderFlag] = useState(false);
  const [jobsFlag, setJobsFlag] = useState(false);
  const [productsFlag, setProductsFlag] = useState(false);
  const [branchesFlag, setBranchesFlag] = useState(false);
  const [aboutFlag, setAboutFlag] = useState(false);
  const [AIFlag, setAIFlag] = useState(false);
  const webName = website?.settings?.website_name;

  // Cards opening effect
  useEffect(()=>{
    if(currentCard === "dashboardCard_homeHeader"){
      setHomeHeaderFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_jobs"){
      setJobsFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_products"){
      setProductsFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_branches"){
      setBranchesFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_about"){
      setAboutFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_AIgenerator"){
      setAIFlag(true);
      return;
    }
  },[currentCard])
  return (
    <div>
      {/* Home page header edit */}
      <DashboardCard _id={"dashboardCard_homeHeader"} text={"שינוי כותרת עמוד הבית"} action={()=>{setHomeHeaderFlag(!homeHeaderFlag);setJobsFlag(false);setProductsFlag(false);setBranchesFlag(false);setAboutFlag(false);setAIFlag(false)}} flag={homeHeaderFlag} setCurrentCard={setCurrentCard} child={<HomeHeaderForm website={website}/>}/>
      
      {/* Categories and products edit */}
      {hasCategories && <DashboardCard _id={"dashboardCard_products"} text={"המוצרים שלי"} action={()=>{setHomeHeaderFlag(false);setJobsFlag(false);setProductsFlag(!productsFlag);setBranchesFlag(false);setAboutFlag(false);setAIFlag(false)}} flag={productsFlag} setCurrentCard={setCurrentCard} child={<ProductForm website={website} setEditPage={setEditPage}/>}/>}
      
      {/* Branches edit */}
      {hasBranches && <DashboardCard _id={"dashboardCard_branches"} text={"הסניפים שלי"} action={()=>{setHomeHeaderFlag(false);setJobsFlag(false);setProductsFlag(false);setBranchesFlag(!branchesFlag);setAboutFlag(false);setAIFlag(false)}} flag={branchesFlag} setCurrentCard={setCurrentCard} child={<BranchForm website={website}/>}/>}
      
      {/* Jobs edit */}
      {hasJobs && <DashboardCard _id={"dashboardCard_jobs"} text={`דרושים ב- ${webName}`} action={()=>{setHomeHeaderFlag(false);setJobsFlag(!jobsFlag);setProductsFlag(false);setBranchesFlag(false);setAboutFlag(false);setAIFlag(false)}} flag={jobsFlag} setCurrentCard={setCurrentCard} child={<AddJobForm website={website}/>}/>}
      
      {/* About edit */}
      <DashboardCard _id={"dashboardCard_about"} text={"אודות"} action={()=>{setHomeHeaderFlag(false);setJobsFlag(false);setProductsFlag(false);setBranchesFlag(false);setAboutFlag(!aboutFlag);setAIFlag(false)}} flag={aboutFlag} setCurrentCard={setCurrentCard} child={<AboutForm website={website}/>}/>

      {/* AI generator page => currently on progress*/}
      {/* <DashboardCard _id={"dashboardCard_AIgenerator"} text={"יצירת עמוד נוסף בAI"} action={()=>{setHomeHeaderFlag(false);setJobsFlag(false);setProductsFlag(false);setBranchesFlag(false);setAboutFlag(false);setAIFlag(!AIFlag)}} flag={AIFlag} setCurrentCard={setCurrentCard} child={<AIPageForm website={website}/>}/> */}
    </div>
  )
}
